import { usExchanges } from "./vars";
import { Settings } from "@/models/auth";

export const PREFERRED_TAB_MODULE = "PreferredStockTab";
export const PREFERRED_TAB_PAGE = "/settings";
export const PREFERRED_TAB_KEY = `${PREFERRED_TAB_MODULE}->${PREFERRED_TAB_PAGE}`;

export const readPreferredStockTab = (settings: Settings | undefined): string => {
    return settings?.module_settings?.[PREFERRED_TAB_KEY]?.value ?? "";
};

export interface StockTabOption {
    href: string;
    label: string;
}

export const STOCK_TAB_OPTIONS: StockTabOption[] = [
    { href: "", label: "Overview" },
    { href: "fundamentals", label: "Fundamentals" },
    { href: "events", label: "Events" },
    { href: "news", label: "News" },
    { href: "corporate-actions/all", label: "Corp Actions" },
    { href: "analysts", label: "Analysts" },
    { href: "eps", label: "EPS Momentum" },
    { href: "holders", label: "Holders" },
    { href: "dividend", label: "Dividend" },
    { href: "options", label: "Options" },
    { href: "short-interest", label: "Shorts" },
    { href: "insiders", label: "Insiders" },
    { href: "peers", label: "Peers" },
    { href: "commodity-exposure", label: "Commodity Exp" },
    { href: "trading-signals", label: "Trading Signals" },
    { href: "stock-scores", label: "Stock Scores" },
];

// Tabs available on ETF pages — mirrors the ETF filter in StockLinks.getLinks.
const ETF_ALLOWED_US = ["events", "corporate-actions", "options", "short-interest", "trading-signals", "dividend"];
const ETF_ALLOWED_NON_US = ["events", "corporate-actions", "short-interest", "trading-signals", "dividend"];

const isTabAvailableOnEtf = (tab: string, isUsExchange: boolean): boolean => {
    const root = tab.split("/")[0];
    return (isUsExchange ? ETF_ALLOWED_US : ETF_ALLOWED_NON_US).includes(root);
};

export const getPreferredTabSuffix = (preferredTab: string | undefined, securityType: string, exchange: string): string => {
    if (!preferredTab) return "";
    if (!STOCK_TAB_OPTIONS.some((o) => o.href === preferredTab)) return "";
    if (securityType === "ETF" && !isTabAvailableOnEtf(preferredTab, usExchanges.includes(exchange))) return "";
    return `/${preferredTab}`;
};
